import {useState, useCallback} from "react";

export type UpdateType = [number, () => void];

export const useUpdate = (): UpdateType => {
  const [state, setState] = useState<number>(0);

  const update = useCallback(
    () => setState((num: number): number => num + 1),
    []
  );

  return [state, update];
};
